module.exports = __webpack_public_path__ + "0a19bcfa2ad6260f10e2aad147dbb71b.svg";